export const isNullOrUndefinedOrEmpty = (value: any): boolean => {
  return value === undefined || value === null || value === '';
};

export const isNullOrUndefinedOrEmptyOrSpace = (value: any): boolean => {
  return isNullOrUndefinedOrEmpty(value) || isNullOrUndefinedOrEmpty(value.trim());
};

export const replaceAll = (content: string, replaceBefore: string, replaceAfter: string): string => {
  return content.replace(new RegExp(escapeRegExp(replaceBefore), 'gm'), replaceAfter);
};

export const copyContent = (content: string): void => {
  const textField: HTMLTextAreaElement = document.createElement('textarea');
  textField.innerText = content;
  document.body.appendChild(textField);
  textField.select();
  document.execCommand('copy');
  textField.remove();
};

export const prefixZero = (num: number, n: number): string => {
  if (num.toString().length < n) {
    return (Array(n).join('0') + num).slice(-n);
  } else {
    return num.toString();
  }
};

export const filterEmptyContent = (content: string, replaceContent?: string): string => {
  return isNullOrUndefinedOrEmpty(content) ? (replaceContent === undefined ? '--' : replaceContent) : content;
};

export const escapeRegExp = str => {
  const reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  const reHasRegExpChar = RegExp(reRegExpChar.source);
  return str && reHasRegExpChar.test(str) ? str.replace(reRegExpChar, '\\$&') : str || '';
};

export const capitalizeFirstLetter = str => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
